import { connect } from 'react-redux'
import ListMenu from '../../../components/Sidebar/ListMenu'
import { getUserRole } from '../../../redux/user/selectors'

const mapStateToProps = (state) => ({
  userRole: getUserRole(state),
})

export default connect(mapStateToProps, null)(ListMenu)
